import { Loading } from '../../components';
import { AccessTokenStatus, useGetBaseUserQuery } from '../../generated/hooks';
import auth from '../../lib/auth';
import ConfirmRegistrationForm from './ConfirmRegistrationForm';
import RegistrationForm from './RegistrationForm';
import { IPropsRegistrationForm } from './common';

const RegistartionFromWithAccessToken = ({ history, lang, channel, countryCode }: IPropsRegistrationForm) => {
  auth.removeUserCookies();
  const { loading, data } = useGetBaseUserQuery();

  if (loading) {
    return <Loading />;
  }

  if (data?.isAccessTokenValid.status === AccessTokenStatus.Revoked && data.isAccessTokenValid.consent) {
    history.push('/login');
  }

  if (data?.isAccessTokenValid.status === AccessTokenStatus.Valid && data?.isAccessTokenValid.baseUser) {
    return (
      <ConfirmRegistrationForm
        firstname={data.isAccessTokenValid.baseUser.firstname}
        surname={data.isAccessTokenValid.baseUser.surname}
        username={data.isAccessTokenValid.baseUser.username}
        organizationName={data.isAccessTokenValid.baseUser.organization!.name}
        history={history}
      />
    );
  }

  return <RegistrationForm history={history} lang={lang} channel={channel} countryCode={countryCode} />;
};

export default RegistartionFromWithAccessToken;
